(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfb-shop-assistant"] && !Shopify.designMode) return;
  try {
    
  const assistants = document.querySelectorAll('.bfb-assistant');

  assistants.forEach((assistant) => {
    const toggle = assistant.querySelector('.bfb-assistant__toggle');
    const panel = assistant.querySelector('.bfb-assistant__panel');
    const close = assistant.querySelector('.bfb-assistant__close');
    const optionButtons = assistant.querySelectorAll('[data-bfb-topic]');
    const answers = assistant.querySelectorAll('[data-bfb-answer]');

    function setOpen(isOpen) {
      panel.hidden = !isOpen;
      toggle.setAttribute('aria-expanded', String(isOpen));
    }

    toggle.addEventListener('click', () => {
      setOpen(panel.hidden);
    });

    close.addEventListener('click', () => {
      setOpen(false);
      toggle.focus();
    });

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const topic = button.getAttribute('data-bfb-topic');
        answers.forEach((answer) => {
          answer.classList.toggle('is-active', answer.getAttribute('data-bfb-answer') === topic);
        });
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) {
        setOpen(false);
        toggle.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
